var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.menuList),function(menu){return _c('el-menu-item',{attrs:{"index":menu.index}},[_vm._v(_vm._s(menu.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }